












































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SecaoTabela extends Vue {
	@Prop({ type: String, default: '' }) titulo!: string
	@Prop({ type: String, default: 'mdi-table' }) icone!: string
	@Prop({ type: Array, default: () => [] }) headers!: any[]
	@Prop({ type: Array, default: () => [] }) items!: any[]
	@Prop({ type: Boolean, default: false }) loading!: boolean
	@Prop({ type: String, default: '' }) atualizadoEm!: string
	// Mapa coluna -> valor já formatado da linha de totalizadores. Se vazio/nulo, a linha não aparece.
	@Prop({ type: Object, default: null }) totais!: Record<string, string> | null
	@Prop({ type: String, default: null }) sortBy!: string | null
	@Prop({ type: Boolean, default: true }) sortDesc!: boolean

	get temTotais(): boolean {
		return !!this.totais && !!this.items.length
	}

	parseVal(v: any): number | string {
		if (typeof v === 'number') return v
		if (typeof v === 'string') {
			const cleaned = v.replace(/R\$\s*/g, '').replace(/\./g, '').replace(',', '.')
			const n = parseFloat(cleaned)
			return isNaN(n) ? v : n
		}
		return v ?? 0
	}

	exportarExcel() {
		import('xlsx').then(XLSX => {
			const wsData: any[][] = [
				this.headers.map(h => h.text),
				...this.items.map(item => this.headers.map(h => item[h.value] ?? '')),
			]
			if (this.totais && this.items.length) {
				wsData.push(this.headers.map((h, i) => i === 0 ? 'TOTAL' : (this.totais![h.value] ?? '')))
			}
			const ws = XLSX.utils.aoa_to_sheet(wsData)
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, this.titulo.slice(0, 31))
			XLSX.writeFile(wb, `${this.titulo}.xlsx`)
		})
	}

	customSortFn(items: any[], sortBy: string[], sortDesc: boolean[]): any[] {
		if (!sortBy.length) return items
		return [...items].sort((a, b) => {
			for (let i = 0; i < sortBy.length; i++) {
				const va = this.parseVal(a[sortBy[i]])
				const vb = this.parseVal(b[sortBy[i]])
				const cmp = typeof va === 'number' && typeof vb === 'number'
					? va - vb
					: String(va).localeCompare(String(vb), 'pt-BR')
				if (cmp !== 0) return sortDesc[i] ? -cmp : cmp
			}
			return 0
		})
	}
}
